// Unpublished Work © 2020 Deere & Company

import t from 'tcomb';
import {searchConstraints, SearchConstraints} from '../../../enum/search-constraints';

export const searchQueryTypes = {
    constraint: 'constraint',
    searchString: 'searchString'
};

export const SearchQuery = t.struct({
    constraint: SearchConstraints,
    searchString: t.String
}, {
    defaultProps: {
        constraint: searchConstraints.STARTS_WITH,
        searchString: ''
    },
    name: 'SearchQuery',
    strict: true
});
